import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Session } from 'src/app/models/session';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { SessionFormComponent } from '../../sessions/form-session/session-form.component';
import { ModalController } from '@ionic/angular';
import { map } from 'rxjs/operators';
import { User } from 'src/app/micro-services/user/models/user';
import { NoteComponent } from 'src/app/components/shared/modals/note/note.component';

@Component({
  selector: 'app-next-appointment',
  templateUrl: './next-appointment.component.html',
  styleUrls: ['./next-appointment.component.scss'],
})
export class NextAppointmentComponent implements OnInit {

  constructor(
    private apiProvider: ApiProviderService,
    private datePipe: DatePipe,
    private userService : UserService,
    private router : Router,
    private modalCtrl: ModalController
    ) { }

  coach: User;
  sessions$: Observable<Session[]> | undefined;
  session: Session[]
  pageNumber: number = 1;

  ngOnInit() {
    this.coach = this.userService.getUser();
    this.sessions$ = this.getData(1);
    this.getData(1).subscribe(sessions => {
      this.session = sessions;
    });
  }

  getData(page: number): Observable<Session[]> {
    return this.apiProvider.getNextSessionsByCoach(this.coach, this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm:ss'), this.pageNumber, 15);
  }

  calendarClick() {
    this.router.navigateByUrl("/coach/sessionDay");
  }

  async prepaClick(session : Session) {

    const noteModal = await this.modalCtrl.create({
      component : NoteComponent,
      componentProps : {session : session}
    });

    noteModal.present();

    const { data, role } = await noteModal.onWillDismiss();
    
  }

  async showClick(session: Session){
    if(!session.clients){
      session.clients = new Array();
    }

    const modalEdition = await this.modalCtrl.create({
      component: SessionFormComponent,
      componentProps: { session : session }
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();
    
    if (role === 'edit') {
      let d : Session = data;
      session = data;
      this.removeSession(d.id);
      this.addSessionToSessions(d);
      
    }
  }

  removeSession(id : number){
    this.sessions$ = this.sessions$.pipe(
      map(sessions => {
        return sessions.filter(session => session.id != id);
      })
    )
  }

  addSessionToSessions(session : Session){
    this.sessions$ = this.sessions$.pipe(
      map((sessions : Session[]) => {
        let newSess : Session[] = [];
        
        if(sessions.length > 0){
          if(new Date(sessions[sessions.length - 1].endDate).getTime() > new Date(session.endDate).getTime()){
            newSess = [...sessions, session];
            newSess.sort((a : Session, b : Session) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime());
          } else {
            newSess = sessions;
          }
        }else{
          newSess = [...sessions, session]
        }
        return newSess
      })
    );
  }

}
